module.exports = __webpack_public_path__ + "static/img/home_logo2.cfa5d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_logo2.png
// module id = RGQh
// module chunks = 3